import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ShipmentPriceService } from '../shipment-price/services/shipment-price.service';
import {
    PackageDetailsTableComponent
} from './components/consolidate-shipments-details/consolidate-shipments-package-details/package-details-table/package-details-table.component';
import { ConsolidateShipmentRoutingModule } from './consolidate-shipments-routing.module'
import { MaterialModule } from '../material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ConsolidateShipmentsManagementComponent } from './components/consolidate-shipments-management.component';
import { MatButtonModule } from '@angular/material/button';
import { CoreModule } from '../../core/core.module';
import { PalletService } from './services/pallet.service';
import { SharedModule } from '../../shared/shared.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { PortalModule } from '@angular/cdk/portal';
import { PortsService } from './services/ports.service';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ProductsService } from '../products/services/products.service';
import { GlobalSettingsService } from '../setting/services/global-settings.service';
import { ConsolidateShipmentsDetailsComponent } from './components/consolidate-shipments-details/consolidate-shipments-details.component';
import { MainConsolidateShipmentsDetailsComponent } from './components/consolidate-shipments-details/main-consolidate-shipments-details/main-consolidate-shipments-details.component';
import { ConsolidateShipmentsDocumentsListComponent } from './components/consolidate-shipments-details/consolidate-shipments-documents-list/consolidate-shipments-documents-list.component';
import { ConsolidateShipmentsShipmentComponent } from './components/consolidate-shipments-details/consolidate-shipments-shipment-details/consolidate-shipments-shipment-details.component'
import { ConsolidateShipmentsPackageDetailsComponent } from './components/consolidate-shipments-details/consolidate-shipments-package-details/consolidate-shipments-package-details.component';
import { PalletsTableComponent } from './components/consolidate-shipments-details/consolidate-shipments-package-details/pallets-table/pallets-table.component';
import { ContainerTableComponent } from './components/consolidate-shipments-details/consolidate-shipments-package-details/container-table/container-table.component';
import { ProductsListComponent } from './components/consolidate-shipments-details/products-list/products-list.component';
import { PickupInfoListComponent } from './components/consolidate-shipments-details/pickup-info-list/pickup-info-list.component';
import { TableConsolidateShipmentsComponent } from './components/table-consolidate-shipments-management/table-consolidate-shipments.component';
import { ConsolidateShipmentPackagesComponent } from './components/consolidate-shipments-details/consolidate-shipment-packages/consolidate-shipment-packages.component';
import { ConsolShipmentDetailsResolver } from './services/resolvers/consol-shipment-details-resolver.service';
import { SaleOrderService } from '../sales-order-management/services/sale-order.service';
import { ConsolidateShipmentsInvoiceListComponent } from './components/consolidate-shipments-details/consolidate-shipments-invoice-list/consolidate-shipments-invoice-list.component';
import { ConsolidateShipmentsInvoiceDocumentListComponent } from './components/consolidate-shipments-details/consolidate-shipments-invoice-document-list/consolidate-shipments-invoice-document-list.component';
import { PaymentService } from '../customers-order-management/services/payment.service';
import { OrderInvoicesService } from './services/consolidate-shipments-invoices.service';
import { PalletDetailsTableComponent } from './components/consolidate-shipments-details/consolidate-shipments-package-details/pallet-details-table/pallet-details-table.component';
import { CityService } from '../../core/services/city.service';
import { ShipmentSummaryComponent } from './components/summary/summary.component';
import { SOTypeConsolSelectPopupPopupComponent } from './components/so-type-consol-select-popup/so-type-consol-select-popup.component';
import { ConsolidatedShipmentsLastMileComponent } from './components/consolidate-shipments-details/consolidated-shipments-last-mile/consolidated-shipments-last-mile.component';
import { WarehouseReviewDialogComponent } from './components/consolidate-shipments-details/consolidated-shipments-last-mile/warehouse-review-dialog/warehouse-review-dialog.component';
import { ConsolShipmentCheckpointsListComponent } from './components/consolidate-shipments-details/consol-shipment-checkpoints-list/consol-shipment-checkpoints-list.component';
import { ConsolidateShipmentStatusCountsComponent } from './components/consolidate-shipments-details/consolidate-shipment-status-counts/consolidate-shipment-status-counts.component';
import { ConsolidateShipmentStatusStatsDialogComponent } from './components/consolidate-shipments-details/consolidate-shipment-status-counts/consolidate-shipment-status-stats-dialog.component';
import { ConsolidateShipmentMilestonesComponent } from './components/consolidate-shipments-details/consolidate-shipment-milestones/consolidate-shipment-milestones.component';
import { ConsolidateShipmentsPnlComponent } from './components/consolidate-shipments-details/consolidate-shipments-pnl/consolidate-shipments-pnl.component';
import { CarriersModule } from '../carriers/carriers.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ConsolidateShipmentRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MaterialModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    CoreModule,
    SharedModule,
    MatDialogModule,
    CdkScrollableModule,
    ScrollingModule,
    PortalModule,
    MatSelectInfiniteScrollModule,
    Ng2TelInputModule,
    NgxMatSelectSearchModule,
    CarriersModule,
  ],
  declarations: [
    ConsolidateShipmentsManagementComponent,
    ConsolidateShipmentsDetailsComponent,
    MainConsolidateShipmentsDetailsComponent,
    PickupInfoListComponent,
    ProductsListComponent,
    ConsolidateShipmentsDocumentsListComponent,
    ConsolidateShipmentsShipmentComponent,
    ConsolidateShipmentsPackageDetailsComponent,
    PalletsTableComponent,
    ContainerTableComponent,
    TableConsolidateShipmentsComponent,
    ConsolidateShipmentPackagesComponent,
    ConsolidateShipmentsInvoiceListComponent,
    ConsolidateShipmentsInvoiceDocumentListComponent,
    PalletDetailsTableComponent,
    ShipmentSummaryComponent,
    SOTypeConsolSelectPopupPopupComponent,
    ConsolidatedShipmentsLastMileComponent,
    WarehouseReviewDialogComponent,
    PackageDetailsTableComponent,
    ConsolShipmentCheckpointsListComponent,
    ConsolidateShipmentMilestonesComponent,
    ConsolidateShipmentStatusCountsComponent,
    ConsolidateShipmentStatusStatsDialogComponent,
    ConsolidateShipmentsPnlComponent
  ],
  providers: [
    ShipmentPriceService,
    PalletService,
    ProductsService,
    GlobalSettingsService,
    PortsService,
    CityService,
    ConsolShipmentDetailsResolver,
    SaleOrderService,
    PaymentService,
    OrderInvoicesService,
    {
      provide: MatDialogRef,
      useValue: {}
    },
  ],
  entryComponents: [
    ConsolidateShipmentStatusStatsDialogComponent,
  ]
})
export class ConsolidateShipmentModule { }
